/* eslint-disable multiline-ternary */
// ** React Imports
import { useEffect, useRef, useState } from 'react'

// ** Custom Components
import Wizard from '@components/wizard'

// ** Steps
import Tyc from './steps/tyc'
import PersonalInfo from './steps/personal-info'
import SendingOTP from './steps/sending-otp'
import ValidationOTP from './steps/validation-otp'
import axios from 'axios'
import jwt_decode from 'jwt-decode'
import { useParams } from 'react-router-dom'

const SignFormWizard = ({
  handleFinish,
  showTC,
  token,
  ids,
  client,
  setMobile,
  mobile,
}) => {
  const ref = useRef(null)
  const [stepper, setStepper] = useState(null)
  const [typeOTP, setTypeOTP] = useState(null)
  const [dataOTP, setDataOTP] = useState(null)
  const [userToRegister, setUserToRegister] = useState({
    lastName: '',
    firstName: '',
    phoneNumber: '',
    documentType: '',
    documentNumber: '',
    birthdate: null,
    email: '',
  })
  const params = useParams()
  const decoded = jwt_decode(token)
  const decodedIssuance = decoded['neo:issuance']
  const isPresential = decodedIssuance === 'link'

  const [requestedOTPStatus, setRequestedOTPStatus] = useState(false)

  const changeRequestedOTPStatus = (value) => {
    setRequestedOTPStatus(value)
    setTypeOTP('phone')
  }

  const validateUserRegistered = async () => {
    const email =
      decoded[
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'
      ]
    const documentId = decoded['DocumentId'].split(',')[0]
    // console.log('params', params.token)
    // const validateSocietyRecord = await axios.get(`${process.env.REACT_APP_API_URL}/documents/${documentId}`, {
    //     token
    // })

    const validateSocietyRequest = await fetch(
      `${process.env.REACT_APP_API_URL}/documents/${documentId}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${params.token}`,
          'Content-Type': 'application/json',
        },
      }
    )

    const validateSocietyRecordData = await validateSocietyRequest.json()

    // console.log('validateSocietyRecordData', validateSocietyRecordData)

    if (!validateSocietyRecordData.societyId) {
      /* validateCustomerRecord.data */
      const validateCustomerRecord = await axios.post(
        `${process.env.REACT_APP_API_URL}/clients/validateCustomerRecord`,
        {
          token,
        }
      )

      if (validateCustomerRecord.data) {
        setDataOTP(validateCustomerRecord.data)
        localStorage.setItem(
          `client-document`,
          validateCustomerRecord.data.documentClient
        )
        localStorage.setItem(
          `client-name`,
          `${validateCustomerRecord.data.firstName} ${validateCustomerRecord.data.lastName}`
        )
      }
    } else {
      const validateCustomerRecordSociety = await axios.get(
        `${process.env.REACT_APP_API_URL}/signatoriesSocieties/${email}`,
        {
          token,
        }
      )

      console.log(
        'validateCustomerRecordSociety',
        validateCustomerRecordSociety
      )
      setDataOTP(validateCustomerRecordSociety.data.data[0])
      localStorage.setItem(
        `client-document`,
        validateCustomerRecordSociety.data.data[0].documentClient
      )
      localStorage.setItem(
        `client-name`,
        `${validateCustomerRecordSociety.data.data[0].firstName} ${validateCustomerRecordSociety.data.lastName}`
      )
    }
  }

  useEffect(() => {
    const visitorData = localStorage.getItem('visitor-data')
    const clientData = localStorage.getItem('client-data')
    if (visitorData || clientData) {
      localStorage.clear()
    }
    validateUserRegistered()
  }, [])

  useEffect(() => {
    if (
      userToRegister.email &&
      userToRegister.phoneNumber &&
      userToRegister.documentNumber &&
      !dataOTP
    ) {
      const dataReg = {
        id: null,
        email: userToRegister.email,
        phone: userToRegister.phoneNumber,
        documentClient: userToRegister.documentNumber,
      }
      localStorage.setItem(`client-document`, JSON.stringify(dataReg))
      localStorage.setItem(
        `client-name`,
        `${userToRegister.firstName} ${userToRegister.lastName}`
      )
      setDataOTP(dataReg)
    }
  }, [userToRegister])

  useEffect(() => {
    const clientName = localStorage.getItem('client-name')
    if (!showTC && stepper && clientName) {
      if (isPresential) {
        handleFinish(true)
      } else {
        stepper.to(4)
      }
    }
  }, [showTC, stepper])

  const onFinish = () => {
    handleFinish(true)
  }

  const steps = isPresential
    ? [
        {
          id: 'tyc',
          title: 'Términos y condiciones',
          subtitle: 'Aceptar términos y condiciones',
          content: (
            <Tyc
              stepper={stepper}
              token={token}
              isMobile={mobile}
            />
          ),
        },
        {
          id: 'validation-otp',
          title: 'Validación de código',
          subtitle: 'Valida el código enviado',
          content: (
            <ValidationOTP
              stepper={stepper}
              dataOTP={dataOTP}
              isMobile={mobile}
              typeOTP={typeOTP}
              userToRegister={userToRegister}
              onFinish={onFinish}
              ids={ids}
              requestedOTPStatus={requestedOTPStatus}
              changeRequestedOTPStatus={changeRequestedOTPStatus}
              isPresential
            />
          ),
        },
      ]
    : [
        {
          id: 'tyc',
          title: 'Términos y condiciones',
          subtitle: 'Aceptar términos y condiciones',
          content: (
            <Tyc
              stepper={stepper}
              token={token}
              isMobile={mobile}
            />
          ),
        },
        {
          id: 'sending-otp',
          title: 'Envió de OTP',
          subtitle: 'Valida la identidad de datos',
          content: (
            <SendingOTP
              stepper={stepper}
              dataOTP={dataOTP}
              showTC={showTC}
              setTypeOTP={setTypeOTP}
            />
          ),
        },
        {
          id: 'validation-otp',
          title: 'Validación de código',
          subtitle: 'Valida el código enviado',
          content: (
            <ValidationOTP
              stepper={stepper}
              dataOTP={dataOTP}
              isMobile={mobile}
              typeOTP={typeOTP}
              userToRegister={userToRegister}
              /*onFinish={onFinish}*/
              ids={ids}
            />
          ),
        },
        {
          id: 'sign-form',
          title: 'Confirmación de datos personales',
          subtitle: 'verifica la información personal',
          content: (
            <PersonalInfo
              stepper={stepper}
              userToRegister={userToRegister}
              token={token}
              setUserToRegister={setUserToRegister}
              setMobile={setMobile}
              onFinish={onFinish}
            />
          ),
        },
        // {
        //     id: 'identity-recognition',
        //     title: 'Prueba de vida',
        //     subtitle: 'Validar prueba de vida',
        //     content: <IdentityRecognition stepper={stepper} client={client} userToRegister={userToRegister} onFinish={onFinish} ids={ids} />
        // }
      ]

  return (
    <div className="horizontal-wizard">
      <Wizard
        instance={(el) => setStepper(el)}
        ref={ref}
        steps={steps}
      />
    </div>
  )
}

export default SignFormWizard
